import i18n, { i18n as I18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { config } from './services/config';
import { logError } from './services/error-logger';

export const SUPPORTED_LANGUAGES =
  config.VITE_ENVIRONMENT === 'production'
    ? (['en'] as const)
    : (['en', 'pt'] as const);

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'always-en',
  lookup: () => 'en',
});

i18n
  .use(HttpApi)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      // default to EN if no language is detected
      order: ['querystring', 'localStorage', 'always-en'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    load: 'languageOnly',
    fallbackLng: false,
    // only support en if i18n is disabled
    // if adding/removing languages, make sure to update the country list locales in frontend/apps/app-web/src/constants/countries.ts
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // react already safe from xss
    },
    saveMissing: true,
    missingKeyHandler(lngs, ns, key, fallbackValue) {
      // eslint-disable-next-line no-console -- dev warning only, not worth a Sentry exception
      console.warn(
        `Missing translation for key in ${lngs[0]}: ${key} (${fallbackValue})`,
      );
    },
    returnEmptyString: false,
    ns: ['translation', 'nif', 'fiscal_rep', 'order'],
  })
  .catch((err) => logError(err));

export default i18n;

export function getCurrentLocale(providedI18n?: I18n): string {
  return (providedI18n || i18n).language?.split('-')[0] ?? 'en';
}
